var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { CustomFormElementResponseDto } from './custom-form-element.response.dto.js';
/**
 * Response DTO for CustomFormSection queries. A form owns an ordered list of
 * sections; each section owns an ordered list of elements (section-scoped
 * index).
 */
export class CustomFormSectionResponseDto {
    id;
    createdAt;
    updatedAt;
    title;
    index;
    customFormId;
    customFormElements;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormSectionResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], CustomFormSectionResponseDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], CustomFormSectionResponseDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormSectionResponseDto.prototype, "title", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], CustomFormSectionResponseDto.prototype, "index", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormSectionResponseDto.prototype, "customFormId", void 0);
__decorate([
    Expose(),
    Type(() => CustomFormElementResponseDto),
    __metadata("design:type", Array)
], CustomFormSectionResponseDto.prototype, "customFormElements", void 0);
//# sourceMappingURL=custom-form-section.response.dto.js.map